import React from "react";
import { Card } from "@shopify/polaris";
import { Col, Row } from "reactstrap";
import ClickFunnels from "../../assets/integrations/clickfunnels.png";
import Intercart from "../../assets/integrations/instacart.png";
import Layout from "./Layout";
const SaleFunnel = () => {
  const listCheckout = [
    {
      title: "Marketing Funnels Made Easy",
      description: "A Website And Sales Funnel Builder For Entrepreneurs",
      logo: ClickFunnels,
      crispEvent: "Clickfunnel",
    },
    {
      title: "Order groceries for delivery",
      description:
        "Whatever you want from local stores, brought right to your door.",
      logo: Intercart,
      crispEvent: "Intercart",
    },
  ];
  return (
    <div style={{ marginTop: "10px" }}>
      <Card sectioned title="Sale Funnel">
        <Row>
          {listCheckout.map((item, index) => {
            return (
              <Col md="4">
                <Layout
                  title={item.title}
                  description={item.description}
                  logo={item.logo}
                  crispEvent={item.crispEvent}
                />
              </Col>
            );
          })}
        </Row>
      </Card>
    </div>
  );
};

export default SaleFunnel;
